const t = {
  name: "Expand",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5858 4L12.5858 10L14 11.4142L20 5.41421V10H22V2H14V4H18.5858Z" fill="currentColor"/>
<path d="M5.41421 20.0001L11.4142 14.0001L10 12.5858L4 18.5858L4 14.0001L2 14.0001V22.0001L10 22.0001V20.0001H5.41421Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Expand
};
